import { api } from '../../shared/api/client';
import { adaptDispute } from '../../shared/api/adapters';
import type { ApiDispute } from '../../shared/types/api';
import type { Dispute } from '../../shared/types/app';

export async function createDispute(requestId: string, payload: { description: string; evidence?: string[] }): Promise<Dispute> {
  const res = await api.post<ApiDispute>(`/api/v1/disputes/request/${requestId}`, payload);
  return adaptDispute(res);
}

export async function fetchDisputeByRequest(requestId: string): Promise<Dispute | null> {
  const res = await api.get<ApiDispute | ApiDispute[] | { data: ApiDispute[] }>(`/api/v1/disputes/request/${requestId}`);
  if (Array.isArray(res)) return res.length > 0 ? adaptDispute(res[0]) : null;
  if ('data' in res) return res.data.length > 0 ? adaptDispute(res.data[0]) : null;
  return adaptDispute(res as ApiDispute);
}
